import React from 'react';
import ReactDOM from 'react-dom';
import '../../assets/css/modal.css';
import { isNullOrUndefined } from './CommonFunctions';

class EQReturnModalDialog extends React.Component {
    constructor(props) {
        super(props);
        this.rootElement = document.getElementById('root');
        this.dialogWrapper = document.createElement('div');       
    }

    componentDidMount() {
        this.rootElement.appendChild(this.dialogWrapper);
        const overlay = document.createElement('div');
        overlay.classList.add('modal');
        overlay.classList.add('page-overlay');
        this.dialogWrapper.appendChild(overlay);
        overlay.addEventListener('click', (e)=> {
            this.props.CloseCallBack();
        })
        if(!isNullOrUndefined(document.querySelector('#EquipmentPopupId'))) {
            document.querySelector('#EquipmentPopupId').focus();
        } 
    }
    componentDidUpdate() {
        if(!isNullOrUndefined(document.querySelector('#EquipmentPopupId'))) {
            document.querySelector('#EquipmentPopupId').focus();
        }  
    }

    


    render() {
        return ReactDOM.createPortal(
            <DialogContent CloseCallBack={this.props.CloseCallBack} DialogRef={this.props.DialogRef} EQhandleKeyMethod={this.props.EQhandleKeyMethod} CustomClass={!isNullOrUndefined(this.props.ClassNames)? this.props.ClassNames: ""}></DialogContent>,
            this.dialogWrapper
          );
    }
}

export default EQReturnModalDialog


const DialogContent = ({ CloseCallBack, DialogRef, EQhandleKeyMethod,CustomClass }) => {
        return (
            <div aria-hidden="false" ref={DialogRef} className="w_modal m_articleModal eq-modal m_tooltipmodal-width vzrf" data-modal="payBill" role="dialog" tapindex="-1" onKeyDown={EQhandleKeyMethod}>
                <div className="modal_header"  data-modal-header id="EquipmentPopupId" tapindex='0'>
                          <button aria-label="Click here or press escape key to close the modal"   className="modal_x m_right m_articleModal-close" data-close-modal=""  onClick={CloseCallBack} id="Equipmentbtn" >
                                &nbsp;</button>
                </div>
                <div className={"modal_content " + CustomClass}  name="storelocationsPanelNew" id="storelocationsPanelNew" tapindex='0'></div>
            </div>
        )
}
 


// WEBPACK FOOTER //
// ./src/components/modules/EQReturnOrderPopup.js